import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RUTAS_BITACORAS } from "../Rutas";
import LayoutGeneral from "../LayoutGeneral";
import "./Bitacoras.css";

const Bitacoras = () => {
  const navigate = useNavigate();
  const [bitacoras, setBitacoras] = useState([]);
  const [loading, setLoading] = useState(true);
  // Restaurar filtros desde sessionStorage si existen
  const [filtroOficina, setFiltroOficina] = useState(() => {
    try { return sessionStorage.getItem('filtroOficina') || ''; } catch (e) { return ''; }
  });
  const [filtroAgente, setFiltroAgente] = useState(() => {
    try { return sessionStorage.getItem('filtroAgente') || ''; } catch (e) { return ''; }
  });
  const [filtroActividad, setFiltroActividad] = useState(() => {
    try { return sessionStorage.getItem('filtroActividad') || ''; } catch (e) { return ''; }
  });
  const [filtroEstatus, setFiltroEstatus] = useState(() => {
    try { return sessionStorage.getItem('filtroEstatus') || ''; } catch (e) { return ''; }
  });
  const [oficinas, setOficinas] = useState([]);
  const [agentes, setAgentes] = useState([]);
  const [actividades, setActividades] = useState([]);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const admin = localStorage.getItem("admin");
  const roles = JSON.parse(localStorage.getItem('roles') || '[]');
  const rolUsuario = roles.length > 0 ? roles[0].idRol : null;
  const puedeVerReporte = roles.some(role => role.idRol === 1 || role.idRol === 2 || role.idRol === 3);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');

  // Persistir filtros en sessionStorage cuando cambian
  useEffect(() => {
    try {
      sessionStorage.setItem('filtroOficina', filtroOficina);
      sessionStorage.setItem('filtroAgente', filtroAgente);
      sessionStorage.setItem('filtroActividad', filtroActividad);
      sessionStorage.setItem('filtroEstatus', filtroEstatus);
    } catch (e) {
      // no-op en entornos sin sessionStorage
    }
  }, [filtroOficina, filtroAgente, filtroActividad, filtroEstatus]);

  useEffect(() => {
    const fetchBitacoras = async () => {
      try {
        const idUsuario = localStorage.getItem("idUsuario");
        const res = await fetch(RUTAS_BITACORAS.GET_BITACORA(idUsuario));
        const data = await res.json();
        setBitacoras(data);
        console.log(data);
      } catch (error) {
        console.error("Error al cargar bitácoras:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBitacoras();
  }, []);

  useEffect(() => {
    const idUsuario = localStorage.getItem("idUsuario");
    // Oficinas
    fetch(RUTAS_BITACORAS.GET_OFICINAS(idUsuario, rolUsuario))
      .then(res => res.json())
      .then(data => setOficinas(data));
    // Agentes
    fetch(RUTAS_BITACORAS.GET_AGENTES)
      .then(res => res.json())
      .then(data => setAgentes(data));
    // Actividades
    fetch(RUTAS_BITACORAS.GET_ACTIVIDADES)
      .then(res => res.json())
      .then(data => setActividades(data));
  }, []);

  const cerrarSesion = () => {
    localStorage.removeItem("usuario");
    navigate("/");
  };
  // Redireccionamientos
  const GoUsuarios = () => { navigate("/Usuarios"); };
  const GoNuevaBitacora = () => navigate("/BitacoraNueva_Seguimiento");
   const GoIncidencias = () => { navigate("/Incidencias"); };

  const bitacorasFiltradas = bitacoras.filter(b =>
    (filtroOficina === "" || b.oficina === filtroOficina) &&
    (filtroAgente === "" || b.nombreAgente === filtroAgente) &&
    (filtroActividad === "" || b.actividad === filtroActividad) &&
    (filtroEstatus === "" || String(b.estatus) === filtroEstatus)
  );

  const handleDescargarExcel = async () => {
    const idUsuario = localStorage.getItem('idUsuario');
    try {
      const response = await fetch(RUTAS_BITACORAS.GET_BITACORA_JEFE_EXCEL(idUsuario, fechaInicio, fechaFin));
console.log("Status:", response.status);

      if (response.ok) {
        console.log('Archivo recibido, iniciando descarga...' + idUsuario + ' - ' + fechaFin);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'reporte_bitacoras.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        alert('Error al descargar el reporte');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error de conexión');
    }
  };

  return ( 
    <LayoutGeneral titulo="Bitacoras">
      <div className="home-container">
        <aside className="sidebar">
          <ul>
            <li onClick={() => navigate("/Home")}><i className="bi bi-house"></i> Inicio</li>
            {admin == 1 && (
              <li onClick={GoUsuarios}><i className="bi bi-people"></i> Usuarios</li>
            )}
             {puedeVerReporte && (
                            <li onClick={GoIncidencias}><i className="bi bi-people"></i> Incidencias</li>
                        )}
            <li onClick={() => navigate("/Bitacoras")}><i className="bi bi-journal"></i> Bitácoras</li>
            <li className="logout" onClick={() => { cerrarSesion(); }}>
              <i className="bi bi-box-arrow-right"></i> Cerrar Sesión
            </li>
          </ul>
        </aside>

        <main className="main-content">
          <div className="d-flex align-items-center mb-3">
            <h2 className="mb-0">Bitácoras</h2>
            <button
              type="button"
              className={`filtro-toggle btn-sm ms-3${mostrarFiltros ? " active" : ""}`}
              onClick={() => setMostrarFiltros(!mostrarFiltros)} title="Mostrar/Ocultar filtros" >
              <i className="bi bi-funnel-fill"></i> Filtros
            </button>
            <button
              type="button"
              className="btn btn-primary btn-nueva-bitacora ms-20"
              onClick={GoNuevaBitacora}  style={{ marginLeft: "auto" }} >
              <i className="bi bi-plus-lg"></i> Nueva Bitácora
            </button>
            {puedeVerReporte && (
              <button type="button" className="btn btn-success ms-2 rounded btn-descargar" data-bs-toggle="modal" data-bs-target="#modalDescargar">
                <i className="bi bi-file-earmark-excel"></i> Descargar Reporte
              </button>
            )}
          </div>

          {mostrarFiltros && (
            <div className="filtros-container p-3 mb-4 rounded shadow-sm">
              {/* Filtros */}
              <div className="row align-items-end">
                <div className="col-md-3 mb-2">
                  <label className="filtro-label">Oficina</label>
                  <select className="form-control filtro-select" value={filtroOficina} onChange={e => setFiltroOficina(e.target.value)} >
                    <option value="">Todas las oficinas</option>
                    {oficinas.map(of => (
                      <option key={of.clave} value={of.descripcion}>
                        {of.descripcion}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3 mb-2">
                  <label className="filtro-label">Agente</label>
                  <select className="form-control filtro-select" value={filtroAgente} onChange={e => setFiltroAgente(e.target.value)} >
                    <option value="">Todos los agentes</option>
                    {agentes.map(a => (
                      <option key={a.codInter} value={a.nombre}>
                        {a.nombre}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3 mb-2">
                  <label className="filtro-label">Actividad</label>
                  <select className="form-control filtro-select" value={filtroActividad} onChange={e => setFiltroActividad(e.target.value)} >
                    <option value="">Todas las actividades</option>
                    {actividades.map(act => (
                      <option key={act.idActividad} value={act.actividad}>
                        {act.actividad}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3 mb-2">
                  <label className="filtro-label">Estatus</label>
                  <select className="form-control filtro-select" value={filtroEstatus} onChange={e => setFiltroEstatus(e.target.value)} >
                    <option value="">Todos</option>
                    <option value="1">Activo</option>
                    <option value="2">Completadas</option>
                  </select>
                </div>
              </div>
              <hr className="my-3" />
            </div>
          )}

          {loading ? (
            <p>Cargando bitácoras...</p>
          ) : bitacorasFiltradas.length > 0 ? (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Editar</th>
                  <th>ID</th>
                  <th>Oficina</th>
                  <th>Clave Agente</th>
                  <th>Nombre Agente</th>
                  <th>Actividad</th>
                  <th>Fecha Contacto</th>
                  <th>Tipo Contacto</th>
                  <th>Motivo</th>
                  <th>Persona</th>
                  <th>Puesto</th>
                  <th>Comentario</th>
                  <th>Estatus</th>
                  <th>Fecha Creación</th>
                </tr>
              </thead>
              <tbody>
                {bitacorasFiltradas.map((b) => (
                  <tr key={b.idBitacora}>
                    <td>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => navigate(`/Bitacora_Seguimiento/${b.idBitacora}`)} 
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button> 
                    </td>
                    <td>{b.idBitacora}</td>
                    <td>
                      {b.oficina
                        ? b.oficina.length > 20
                          ? b.oficina.substring(0, 20) + " ..."
                          : b.oficina
                        : "N/A"}
                    </td>
                    <td>{b.claveAgente ? b.claveAgente : "N/A"}</td>
                    <td>
                      {b.nombreAgente
                       ? b.nombreAgente.length > 25
                         ? b.nombreAgente.substring(0, 25) + " ..."
                         : b.nombreAgente
                       : "N/A"}
                    </td>
                    <td>{b.actividad}</td>
                    <td>{b.fechaContacto}</td>
                    <td>{b.tipoContacto ? b.tipoContacto : "N/A"}</td>
                    <td>{b.motivoContacto ? b.motivoContacto : "N/A"}</td>
                    <td>{b.personaContacto ? b.personaContacto : "N/A"}</td>
                    <td>{b.puestoContacto ? b.puestoContacto : "N/A"}</td>
                    <td>
                      {b.comentario
                        ? b.comentario.length > 15
                          ? b.comentario.substring(0, 15) + " ..."
                          : b.comentario
                        : "N/A"}
                    </td>
                    <td>{Number(b.estatus) === 1 ? "Activo" : "Completado"}</td>
                    <td>{b.fechaCreacion}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="alert alert-info">No hay bitácoras registradas.</div>
          )}
        </main>
      </div>

      {/* Modal para descargar reporte */}
      <div className="modal fade" id="modalDescargar" tabIndex="-1" aria-labelledby="modalDescargarLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalDescargarLabel">Descargar Reporte de Bitácoras</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="fechaInicio" className="form-label">Fecha Inicio</label>
                <input
                  type="date"
                  className="form-control"
                  id="fechaInicio"
                  value={fechaInicio}
                  onChange={(e) => setFechaInicio(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="fechaFin" className="form-label">Fecha Fin</label>
                <input
                  type="date"
                  className="form-control"
                  id="fechaFin"
                  value={fechaFin}
                  onChange={(e) => setFechaFin(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="button" className="btn btn-primary" onClick={() => { handleDescargarExcel(); setFechaInicio(''); setFechaFin(''); }} data-bs-dismiss="modal">Descargar</button>
            </div>
          </div>
        </div>
      </div>
    </LayoutGeneral>
  );
};

export default Bitacoras;
